//以下のテキストの色を変更
$(".schedule_table td:contains('1月お休み')").css("color", "#E60012");
$(".schedule_table td:contains('2月お休み')").css("color", "#E60012");
$(".schedule_table td:contains('3月お休み')").css("color", "#E60012");
$(".schedule_table td:contains('4月お休み')").css("color", "#E60012");
$(".schedule_table td:contains('5月お休み')").css("color", "#E60012");
$(".schedule_table td:contains('6月お休み')").css("color", "#E60012");
$(".schedule_table td:contains('7月お休み')").css("color", "#E60012");
$(".schedule_table td:contains('8月お休み')").css("color", "#E60012");
$(".schedule_table td:contains('9月お休み')").css("color", "#E60012");
$(".schedule_table td:contains('10月お休み')").css("color", "#E60012");
$(".schedule_table td:contains('11月お休み')").css("color", "#E60012");
$(".schedule_table td:contains('12月お休み')").css("color", "#E60012");
